import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Box, MenuItem, Select, SelectProps, styled, useTheme } from '@mui/material';

export const CerebroDropdownIcon: React.FC<{ className: string }> = ({ className }) => {
	const isOpen = className.includes('Open');
	const theme = useTheme();

	return (
		<Box
			sx={{
				backgroundColor: isOpen ? theme.palette.primary.main : 'transparent',
				borderRadius: '2px',
				marginRight: 0.5,
				top: 'unset !important',
				position: 'absolute',
				right: 0,
				transition: theme.transitions.create('background-color'),
				pointerEvents: 'none',
				cursor: 'pointer',
			}}
		>
			<StyledIcon
				icon={faChevronDown}
				sx={{
					transform: isOpen ? 'rotate(180deg)' : 'none',
					transition: theme.transitions.create('transform'),
				}}
			/>
		</Box>
	);
};

const StyledIcon = styled(FontAwesomeIcon)({
	display: 'block',
	margin: 8,
	height: 16,
	width: '16px !important',
});
